import { render, staticRenderFns } from "./TopPerformedIbView.vue?vue&type=template&id=6b81aea9"
import script from "./TopPerformedIbView.vue?vue&type=script&lang=js"
export * from "./TopPerformedIbView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports